/* Minimal publish/subscribe used by Dawn's components.
   ---------------------------------------------------------
   This file is absent from this theme copy but is requested unconditionally
   by layout/theme.liquid, so it was 404ing on every page load. global.js
   and cart.js call subscribe()/publish() at element-connect time, which
   would throw a ReferenceError as soon as a <quantity-input> or
   <cart-items> element appeared.

   The contract is fully determined by the five call sites in this theme:
     assets/global.js:232                subscribe(...) -> unsubscriber
     assets/global.js:1075               publish(name, payload)
     assets/cart.js:38                   subscribe(...) -> unsubscriber
     assets/cart.js:256                  publish(name, payload)
     assets/standard-actions-override.js publish(name, payload)

   Event names come from PUB_SUB_EVENTS in constants.js. */

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  // Callers store this and invoke it on disconnect
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
